export default __webpack_public_path__ + "static/media/015-pharmacy.77bd4e57.svg";